import { addMember } from "db";
import { SHOW_ALERT } from "./ui";
import { setupMember, deleteMember } from "helpers/https";
import { getNormalMembersRef, getCounselorsRef } from "db";

export const MEMBER_ADD_OK = 'member add ok';
export const MEMBER_ADD_FAIL = 'member add fail';
export const FETCH_MEMBERS_OK = 'fetch members ok';
export const FETCH_COUNSELORS_OK = 'fetch counselors ok';

export const addMemberAction = (org_id, params) => dispatch => {
  addMember(org_id, params)
    .then(() => dispatch(
      {
        type: MEMBER_ADD_OK,
        payload: params
      }
    ))
    .catch(e => dispatch({
      type: MEMBER_ADD_FAIL,
      payload: e
    }))
}

export const getMembersAction = (org_id) => dispatch => {
  return getNormalMembersRef(org_id)
    .onSnapshot(members => {
      dispatch({
        type: FETCH_MEMBERS_OK,
        payload: members.docs.filter(doc => doc.data().is_counselor === undefined || doc.data().is_counselor === false)
      });
    }, e => {
      const message = e.code === 'permission-denied'
        ? '권한이 없습니다. 관리자에게 문의해주세요.'
        : `에러가 발생했습니다. ${e.message}`
      return dispatch({
        type: SHOW_ALERT,
        payload: {
          message,
          color: 'danger',
        }
      });
    });
}

export const getCounselorsAction = (org_id) => dispatch => {
  return getCounselorsRef(org_id)
    .onSnapshot(members => {
      dispatch({
        type: FETCH_COUNSELORS_OK,
        payload: members.docs
      });
    }, e => {
      const message = e.code === 'permission-denied'
        ? '권한이 없습니다. 관리자에게 문의해주세요.'
        : `에러가 발생했습니다. ${e.message}`
      return dispatch({
        type: SHOW_ALERT,
        payload: {
          message,
          color: 'danger',
        }
      });
    });
}


export const createMemberAction = (org_id, params) => dispatch => {
  if (!org_id) {
    dispatch({
      type: SHOW_ALERT,
      payload: {
        message: "기관을 먼저 선택해주세요",
        color: "danger"
      }
    })
  }

  // check if the user already exists
  return setupMember({ ...params, org_id })
    .then(({ org_id, user_id, params }) => {

      console.log("user_id = ", user_id);
      console.log("org_id = ", org_id);
      console.log("params = ", params);

      return dispatch({
        type: SHOW_ALERT,
        payload: {
          message: "추가되었습니다.",
          color: "danger"
        }
      });
    })
}

export const deleteMemberAction = (user_id, org_id) => dispatch => {
  if (!org_id) {
    dispatch({
      type: SHOW_ALERT,
      payload: {
        message: "기관을 먼저 선택해주세요",
        color: "danger"
      }
    })
  }

  return deleteMember({ user_id, org_id })
    .then(() => {
      return dispatch({
        type: SHOW_ALERT,
        payload: {
          message: "삭제되었습니다.",
          color: "danger"
        }
      });
    })
}
